import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { SwUploadService } from 'src/app/librarys/serves/public/sw-upload.service';
declare var $: any;

@Component({
  selector: 'sw-qr-code',
  templateUrl: './sw-qr-code.component.html',
  styleUrls: ['./sw-qr-code.component.css']
})
export class SwQrCodeComponent implements OnInit {

  /** 
   * 二维码链接
   * @ignore
   */
  @Input() value:string = 'http://www.baidu.com' 

  /** 
   * 二维码大小
   * @ignore
   */
   @Input() size:number = 100

  /** 
   * 二维码容错率级别
   * @ignore
   */
   @Input() level:string = 'H'

   /** 
    * 二维码背景颜色
    * @ignore
    */
    @Input() background:string = 'white'

  /** 
    * 二维码背景透明度
    * @ignore
    */
    @Input() backgroundAlpha:number = 1.0

  /** 
   * 二维码前景颜色
   * @ignore
   */
    @Input() foreground:string = 'black'

  /** 
    * 二维码前景透明度
    * @ignore
    */
    @Input() foregroundAlpha:number = 1.0

  /** 
   * 二维码的padding值
   * @ignore
   */
    @Input() padding:number = null

  /** 
   * 二维码logo图片的链接，可以是 图片地址 或是 base64
   * @ignore
   */
    @Input() logoUrl:string = ''

  /** 
   * 是否有加logo图片和美化二维码功能,默认没有
   * @ignore
   */ 
    @Input() logoAndBeautify:boolean = false

    /** 
     * 画logo时创建的 img 标签
     * @ignore
     */ 
    logoDom:any

  constructor(
    private el:ElementRef,
    private swUploadService:SwUploadService
    ) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    if(this.logoUrl){
      //如果初始值就有logo图片，就要在二维码上吧logo回显出来
      const canvas = this.el.nativeElement.querySelector('canvas');
      const size = canvas.width;
      const logo = document.createElement('img');
      logo.style.width = size * 0.3 + 'px'
      logo.style.height = size * 0.3 + 'px'
      document.body.appendChild(logo);
      this.logoDom = logo
      canvas.getContext('2d').drawImage(logo, size * 0.35, size * 0.35, size * 0.3, size * 0.3);
      document.body.removeChild(logo);
    }
  }
  
  /**
   * 上传logo
   */
  uploadLogo(){
    $('#myUploadLogo')[0].click()
  }

  /**
   * 隐藏的 input[type="file"] 选中文件后触发
   * @param event 
   * @returns 
   */
  fileChange2(event){
    //设置请求参数
    let file = event.target.files[0]
    var type = file.type.split('/')[0];
    if (type != 'image') {
        alert('请上传图片');
        return;
    }

    //var size = Math.floor(file.size / 1024 / 1024);
    //if (size > 3) {
    //    alert('图片大小不得超过3M');
    //    return;
    //};
    const canvas = this.el.nativeElement.querySelector('canvas');
    const size = canvas.width;
    const logo = document.createElement('img');
    logo.style.width = size * 0.3 + 'px'
    logo.style.height = size * 0.3 + 'px'
    document.body.appendChild(logo);
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = ()=> {
      //这里原来的写法是 reader.onload = function(){}  由于闭包和异步的问题，获取不到外部的this,this指向的是 FileReader，此时下面是 let src = this.result.toString();
      // 所以改成了上面的用法,下面这行也改成了 reader.result
      let src = reader.result.toString()
      logo.setAttribute('src', src); 
      this.logoDom = logo
      // logo.setAttribute('style', 'display:none');
      //先将logo图片上传
      setTimeout(() => {
        canvas.getContext('2d').drawImage(logo, size * 0.35, size * 0.35, size * 0.3, size * 0.3);
        document.body.removeChild(logo);
        // const image = $('#myimg')[0];
        // image.src = canvas.toDataURL('image/png');
        
      }, 20);
      
    };

    
  }

  /**
   * 美化二维码
   */
  beautify(){
    // canvas 部分
    var canvas = $("canvas")[0];
    var ctx = canvas.getContext("2d");
    for (var i = 0; i < this.size; i++) { 
    　this.book[i] = []; 
    　for (var j = 0; j < this.size; j++) { 
      　　this.book[i][j] = 0; 
    　} 
    }
    this.imgD = ctx.getImageData(0, 0, this.size, this.size);  //它可复制画布上指定的矩形的像素数据
      
    for (var i = 0; i < this.size; i++) {
      for (var j = 0; j < this.size; j++) {
        if (this.book[i][j] == 0 && this.checkColor(i, j, this.size, this.bg)) { //没标记过 且是非背景色
          this.book[i][j] = 1;
          var color = this.colorRgb(this.colors[this.ranNum()]);
          this.dfs(i, j, color); //深度优先搜索
        }
      }
    }
    ctx.putImageData(this.imgD, 0, 0);  //将图像数据（从指定的 ImageData 对象）放回画布上
    //如果已经上传过logo，重新写一次logo,避免logo被覆盖
    if(this.logoDom){
      canvas.getContext('2d').drawImage(this.logoDom, this.size * 0.35, this.size * 0.35, this.size * 0.3, this.size * 0.3);
    }
 
    
  }

  ranNum() {
    var len = this.colors.length;
    return Math.floor(Math.random() * len);
  }

  // 方向数组
  next:any[] = [
    [0, 1], //右
    [1, 0], //下
    [0, -1], // 左
    [-1, 0] //上 
  ];

  /***参数***/
  bg = this.colorRgb("#fff"); //忽略的背景色
  imgD:any; //预留给 像素信息数组
  colors = ["#368BFF", "#EF2767", "#F17900", "#399690", "#5aa6f7", "#fd417e", "#ffc000", "#59b6a6"]; //染色数组
  book:any[] = []

  // 分离颜色参数 返回一个数组
  colorRgb(str){
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    var sColor = str.toLowerCase();
    if (sColor && reg.test(sColor)) {
      if (sColor.length === 4) {
        var sColorNew = "#";
        for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
        }
        sColor = sColorNew;
      }
      //处理六位的颜色值 
      var sColorChange = [];
      for (var i = 1; i < 7; i += 2) {
        sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
      }
      return sColorChange;
    } else {
      sColorChange = sColor.replace(/(rgb\()|(\))/g, "").split(",").map(function(a) {
        return parseInt(a);
      });
      return sColorChange;
    }
  }

  // 返回对应像素点的序号
  calc(width, i, j) {
    if (j < 0) {
      j = 0;
    }
    return 4 * (i * width + j);
  }

  // 验证该位置的像素 不是背景色为true
  checkColor(i, j, width, bg) {
    var x = this.calc(width, i, j);
 
    if (this.imgD.data[x] != bg[0] && this.imgD.data[x + 1] != bg[1] && this.imgD.data[x + 2] != bg[2]) {
     return true;
    } else {
     return false;
    }
  }

  
  // 改变颜色值
  changeColor(i, j, colorArr) {
    var x = this.calc(this.size, i, j);
    this.imgD.data[x] = colorArr[0];
    this.imgD.data[x + 1] = colorArr[1];
    this.imgD.data[x + 2] = colorArr[2];
   }

   // 深度优先搜索 
  dfs(x, y, color) {
    this.changeColor(x, y, color);
    for (var k = 0; k <= 3; k++) {
    // 下一个坐标
    var tx = x + this.next[k][0];
    var ty = y + this.next[k][1];
    
    //判断越界
    if (tx < 0 || tx >= this.size || ty < 0 || ty >= this.size) {
      continue;
    }
    
    
    if (this.book[tx][ty] == 0 && this.checkColor(tx, ty, this.size, this.bg)) {
      // 判断位置
      this.book[tx][ty] = 1;
      this.dfs(tx, ty, color);
    }
    
    }
    return;
  }
}
